import React from 'react';
import PropTypes from 'prop-types';
import { Box, IconButton } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { GREEN } from '../../../Assets/Constants/theme.js';

const ApprovedStatusBox = ({
	status,
	tabValue = 0,
	showInfo,
	handleComment,
	rowData
}) => (
	<Box
		sx={{
			width: '50%',
			minWidth: '70px',
			height: '80%',
			borderRadius: '8px',
			color: GREEN,
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'start'
		}}
	>
		<span>{status.charAt(0).toUpperCase() + status.slice(1)}</span>
		{status.toLowerCase() === 'close' && tabValue === 2 && showInfo && (
			<Box>
				<IconButton onClick={() => handleComment(rowData)}>
					<InfoOutlinedIcon />
				</IconButton>
			</Box>
		)}
	</Box>
);

ApprovedStatusBox.propTypes = {
	status: PropTypes.string,
	tabValue: PropTypes.any,
	showInfo: PropTypes.any,
	handleComment: PropTypes.func,
	rowData: PropTypes.any
};

export default ApprovedStatusBox;
